import { AfterViewInit, Directive, Input, Optional } from '@angular/core';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { GasFiltersDirective } from '../../common/gas-filters/gas-filters.directive';
import { GasInputComponent } from '../../forms/gas-input/input/gas-input.component';
import { GasCheckboxComponent } from '../../forms/gas-checkbox/checkbox/gas-checkbox.component';
import { GasForm } from '../../forms/gas-form.namespace';
import { GasFormBaseComponent } from '../../forms/gas-form-base-component';
import { GasSwitchComponent } from '../../forms/gas-switch/switch/gas-switch.component';
import { GasSelectComponent } from '../../forms/gas-select/wrapper/gas-select.component';
import { GasRadioGroupComponent } from '../../forms/gas-radio/group/gas-radio-group.component';
import { GasDateDirective } from '../gas-date-directive/gas-date.directive';
import { GasDatepickerInputComponent } from '../../forms/gas-datepicker-input/gas-datepicker-input.component';
import { GasAutocompleteComponent } from '../../forms/gas-autocomplete/wrapper/gas-autocomplete.component';
import { GasStatusTagGroupComponent } from '../../forms/gas-status-tag/group/group.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({
  selector: '[gasFormKey]',
})
export class GasFormKeyDirective implements AfterViewInit {

  @Input()
  public gasFormKey: string;

  public get component(): GasFormBaseComponent {
    return this.gasInputComponent
      || this.gasCheckBoxComponent
      || this.gasSwitchComponent
      || this.gasSelectComponent
      || this.gasRadioGroupComponent
      || this.gasDatepickerInputComponent
      || this.gasAutocompleteComponent
      || this.gasStatusTagGroupComponent;
  }

  public get dateInfo(): GasDateDirective {
    return this.gasDateDirective;
  }

  public get tagName(): string {
    return this.tag;
  }

  public set tagName(name: string) {
    this.tag = name;
  }

  private tag = '';

  constructor(
    @Optional() public gasFiltersDirective: GasFiltersDirective,
    @Optional() private gasInputComponent: GasInputComponent,
    @Optional() private gasCheckBoxComponent: GasCheckboxComponent,
    @Optional() private gasSwitchComponent: GasSwitchComponent,
    @Optional() private gasSelectComponent: GasSelectComponent,
    @Optional() private gasRadioGroupComponent: GasRadioGroupComponent,
    @Optional() private gasDateDirective: GasDateDirective,
    @Optional() private gasDatepickerInputComponent: GasDatepickerInputComponent,
    @Optional() private gasAutocompleteComponent: GasAutocompleteComponent,
    @Optional() private gasStatusTagGroupComponent: GasStatusTagGroupComponent,
  ) {
  }

  public ngAfterViewInit(): void {
    if (this.gasFiltersDirective) {
      this.init();
    }
  }

  public init(): void {
    this.gasFiltersDirective.addControl(this.gasFormKey, this.component.form);

    this.checkValueAndSetModified();

    this.component.form.valueChanges
      .pipe(
        distinctUntilChanged(),
        map(value => ( { formValue: value, component: this.component } )),
        untilDestroyed(this),
      )
      .subscribe(() => {
        // Чтобы изменение null на null при ресетах фильтра нам не добавляло лишних модификаций
        if (!this.gasFiltersDirective.modifiedKeys.includes(this.gasFormKey)) {
          this.checkValueAndSetModified();
        }

        /** проверяем наличие ошибки в gas-range */
        setTimeout(() => {
          if (this.component instanceof GasInputComponent) {
            this.gasFiltersDirective.gasFiltersComponent.disabledApplyButtonSubject$.next(this.gasFiltersDirective.filterGroup.invalid);
          }
        });

        // Меняем состояние, только если ключ в списке изменений (исключаем первое изменение null на null)
        if (this.gasFiltersDirective.modifiedKeys.includes(this.gasFormKey)) {
          this.gasFiltersDirective.state = GasForm.InputState.Primary;
        }
      });
  }

  private checkValueAndSetModified(): void {
    const value = this.component.form.value;
    const isArray = Array.isArray(value);
    // Смотрим на заполненность массива или значение, отличное от null и undefined
    if (( isArray && value.length > 0 ) || ( !isArray && value != null )) {
      this.gasFiltersDirective.modifiedKeys.push(this.gasFormKey);
      this.gasFiltersDirective.modifiedInputs.push(this);
    }
  }
}
